module.exports = "#video {\n  width: 100%;\n  height: 100%; }\n  #video object, #video embed {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    z-index: 0; }\n\n.poster {\n  background-size: cover;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/video-player/flash-hls-fallback/vg-flash.media/vg-flash.media.style.scss
// module id = 788
// module chunks = 2